import React from "react";

const RELOAD_MARKER = "chunk-reload-attempted";

const isChunkError = (error) => {
    if (!error) {
        return false;
    }
    if (error.name === "ChunkLoadError") {
        return true;
    }
    return /Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed|Unexpected token '<'/i
        .test(error.message ?? "");
};

class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
            this.setState({error: null});
        }
    }

    componentDidCatch(error) {
        if (!isChunkError(error)) {
            return;
        }

        let alreadyReloaded = false;
        try {
            alreadyReloaded = sessionStorage.getItem(RELOAD_MARKER) === "1";
            if (!alreadyReloaded) {
                sessionStorage.setItem(RELOAD_MARKER, "1");
            }
        } catch (storageError) {
            alreadyReloaded = true;
        }

        if (!alreadyReloaded) {
            window.location.reload();
        }
    }

    render() {
        const {error} = this.state;

        if (!error) {
            return this.props.children;
        }

        if (!isChunkError(error)) {
            throw error;
        }

        return this.props.fallback ?? null;
    }
}

export const clearChunkReloadMarker = () => {
    try {
        sessionStorage.removeItem(RELOAD_MARKER);
    } catch (storageError) {
        return;
    }
};

export default ChunkErrorBoundary;
